<template>
    <div>
        <div class="row" v-if="!coordsFound && locationPermission !== 'granted' && locationPermission !== 'overridden'">
            <div class="col-sm-12">
                <div class="card">
                    <h5 class="card-header">{{ $t('location-access') }}</h5>
                    <div class="card-body">
                        <h5 class="card-title">{{ cardTitle }}</h5>
                        <p class="card-text">{{ cardText }}</p>
                        <b-button :class="visible ? 'primary' : 'collapsed'" class="mx-1 my-1" variant="outline-primary"
                            :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse"
                            @click="visible = !visible">
                            {{ $t('how-to-enable-question-mark') }}
                        </b-button>

                        <b-collapse id="collapse" v-model="visible">
                            <BrowserInstructions :browser="browser" />
                        </b-collapse>

                        <div class="float-right">
                            <b-button class=" mx-1 my-1" @click="requestAnyway()">
                                {{ $t('skip-location-check') }}
                            </b-button>
                            <b-button class="mx-1 my-1" variant="primary" @click="retryLocationPermission()">
                                {{ $t('retry') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BrowserInstructions from "src/components/GeoLoc/BrowserInstructions";

export default {
    components: {
        BrowserInstructions
    },
    data() {
        return {
            locationPermission: '',
            visible: null,
            browser: {},
            coordsFound: false,
            test: this.$browserDetect.meta.name
        }
    },
    created() {
        this.detectBrowser();
        // console.log(this.browserInfo);
    },
    mounted() {
        if (navigator.geolocation) {
            this.checkLocationPermission();
        } else {
            this.locationPermission = "unsupported";
        }
    },
    methods: {
        checkLocationPermission() {
            return new Promise((resolve, reject) => {
                navigator.permissions
                    .query({ name: "geolocation" })
                    .then((permissionStatus) => {
                        this.locationPermission = permissionStatus.state;
                        this.sendToParent();
                        permissionStatus.onchange = () => {
                            this.checkLocationPermission();
                        };
                        //Check how to handle FF's temporary perms
                        resolve(this.locationPermission);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        retryLocationPermission() {
            this.checkLocationPermission();
        },
        getUserLocation() {
            if (navigator.geolocation) {
                return new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(
                        position => {
                            resolve(this.getCoords(position));
                        },
                        error => {
                            this.locationPermission ='error';
                            reject(this.showError(error));
                        }
                    );
                });
            } else {
                this.$log.notice.call(this, "Geolocation is not supported by this browser.");
            }
        },
        getCoords(position) {
            if (position.coords) {
                this.coordsFound = true;
                this.locationPermission = 'granted';
            }
            this.$log.info.call(this, position);
            return [position.coords.latitude, position.coords.longitude];
        },
        showError(error) {
            var msg = 'Unknown Error';
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    msg = "User denied the request for Geolocation.";
                    break;
                case error.POSITION_UNAVAILABLE:
                    msg = "Location information is unavailable.";
                    break;
                case error.TIMEOUT:
                    msg = "The request to get user location timed out.";
                    break;
                case error.UNKNOWN_ERROR:
                    msg = "An unknown error occurred.";
                    break;
            }
            this.$log.notice.call(this, msg);
            return msg;
        },
        detectBrowser() {
            /*const userAgent = navigator.userAgent.toLowerCase();
            const browsers = {
                chrome: "Google Chrome",
                firefox: "Mozilla Firefox",
                safari: "Apple Safari",
                iossafari: "Apple Safari iOS",
                edge: "Microsoft Edge",
                opera: "Opera",
                ie: "Internet Explorer",
            };

            var detectedBrowser = Object.keys(browsers).find((browser) =>
                userAgent.includes(browser)
            );
            if (detectedBrowser == 'safari') {
                if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
                    detectedBrowser = 'iossafari';
                }
            }*/
            if (navigator && navigator.userAgentData && this.$browserDetect) {
                const browserMapping = {
                    isBrave: { caption: this.$t('brave-browser'), name: "brave" },
                    isChrome: { caption: this.$t('chrome-browser'), name: "chrome" },
                    isChromeIOS: { caption: this.$t('ioschrome-browser'), name: "ioschrome" },
                    isEdge: { caption: this.$t('edge-browser'), name: "edge" },
                    isFirefox: { caption: this.$t('firefox-browser'), name: "firefox" },
                    isIE: { caption: this.$t('msie-browser'), name: "msie" },
                    isIOS: { caption: this.$t('iossafari-browser'), name: "iossafari" },
                    isSafari: { caption: this.$t('safari-browser'), name: "safari" },
                    isOpera: { caption: this.$t('opera-browser'), name: "opera" },
                };
                this.browser = browserMapping[Object.keys(this.$browserDetect).find(key=>this.$browserDetect[key])] || {
                    caption: this.$t('unknown-browser'),
                    name: "unknown-browser"
                };
            } else {
                this.browser = {
                    caption: this.$t('undetermined-browser'),
                    name: "undetermined-browser"
                };
            }

            return this.browser.caption;
        },
        sendToParent() {
            if (this.locationPermission === 'overridden') {
                this.$emit('geoloc-done', {
                    locationPermission: this.locationPermission,
                    coords: {
                        lat: null,
                        long: null
                    },
                    browser: new Promise(resolve => {
                        resolve(this.browser.caption);
                    }),
                    GeoLocLoading: false
                });
            } else {
                this.getUserLocation().then(res => {
                    this.$emit('geoloc-done', {
                        locationPermission: this.locationPermission,
                        coords: {
                            lat: res[0],
                            long: res[1]
                        },
                        GeoLocLoading: false
                    });
                }).catch((error) => {
                    this.$log.notice.call(`The following error happened: ${error}`);
                });
            }
        },
        requestAnyway() {
            this.error = null;
            this.locationPermission = 'overridden';
            this.sendToParent();
        }
    },
    computed: {
        cardTitle() {
            switch (this.locationPermission) {
                case 'prompt':
                    return this.$t('location-access-pending');
                case 'denied':
                    return this.$t('location-access-denied');
                case 'error':
                    return this.$t('error');
                default:
                    return this.$t('loading');
            }
        },
        cardText() {
            switch (this.locationPermission) {
                case 'prompt':
                    return this.$t('location-access-pending-text');
                case 'denied':
                    return this.$t('location-access-denied-text');
                case 'error':
                    return this.$t('location-error-text');
                default:
                    return this.$t('loading');
            }
        },
    },
}
</script>
